export default __webpack_public_path__ + "static/media/aquasil-table.fde95c9e.svg";